import React from 'react';
import PropTypes from 'prop-types';
import './timeStamp.css';

const TimeStamp = ({ timestamp }) => {
  return (
    <div className="timestamp-wrapper">
      {timestamp ? timestamp : 'No date available'}
    </div>
  );
};

TimeStamp.propTypes = {
  timestamp: PropTypes.string,
};

export default TimeStamp;
